import editWaypointsWorkflow from './editWaypointsWorkflow';

/**
 * Function to run when the waypoint list is edited.
 *
 * @callback
 * @param {*} arg - The object argument.
 * @param {object} arg.event - The event fired after editing the waypoint list.
 * @param {Function} arg.getCurrentMapState - A function that gets the current variables needed from the map component.
 */
const editWaypoints = ({ event, getCurrentMapState }) => {
  const { editWayPointsActive } = getCurrentMapState();
  if (editWayPointsActive) {
    editWaypointsWorkflow({ event, getCurrentMapState });
  }
};

export default editWaypoints;
